import { useRef, useEffect, useCallback, useState } from "react";

const AutoComplete = ({
  onAddressSelect,
  name,
  id,
  placeholder,
  latitude,
  longitude,
  value,
  country,
  state,
  city,
}) => {
  const autoCompleteRef = useRef(null);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState(value || "");

  const initAutocomplete = useCallback(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps API is not available.");
      return;
    }

    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["establishment","geocode"],
      }
    );

    autoCompleteRef.current.addListener("place_changed", () => {
      const place = autoCompleteRef.current.getPlace();

      if (!place || !place.geometry || !place.geometry.location) {
        console.error("Invalid place data received.");
        return;
      }

      // Call the onAddressSelect callback with the formatted address
      onAddressSelect(place.formatted_address);

      // Update the input value with the selected address
      setInputValue(place.formatted_address);

      // Extract latitude and longitude from the place object
      const { lat, lng } = place.geometry.location;
      latitude(lat());
      longitude(lng());

      // Extract country, state, and city from the place object
      if (place.address_components) {
        const addressComponents = place.address_components;
        const countryObj = addressComponents.find((component) =>
          component.types.includes("country")
        );
        const stateObj = addressComponents.find((component) =>
          component.types.includes("administrative_area_level_1")
        );
        const cityObj = addressComponents.find((component) =>
          component.types.includes("locality") ||
          component.types.includes("administrative_area_level_2")
        );

        if (countryObj) country(countryObj.long_name);
        if (stateObj) state(stateObj.long_name);
        if (cityObj) city(cityObj.long_name);
      }
    });
  }, [onAddressSelect, latitude, longitude, country, state, city]);

  useEffect(() => {
    if (!window.google) {
      // const script = document.createElement("script");
      // script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places`;
      // script.async = true;
      // script.defer = true;
      // script.onload = initAutocomplete;

      // document.head.appendChild(script);

      // return () => {
      //   // Cleanup script tag when unmounting
      //   document.head.removeChild(script);
      // };
    } else {
      initAutocomplete();
    }
  }, [initAutocomplete]);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  return (
    <div>
      <input
        type="text"
        autoComplete="off"
        name={name}
        id={id}
        value={inputValue}
        placeholder={placeholder}
        className="form-control"
        ref={inputRef}
        onChange={(e) => setInputValue(e.target.value)}
        required
      />
    </div>
  );
};

export default AutoComplete;
